'use strict';

var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var AlertMessage = require('./AlertMessage.js');
var classNames = require('classnames');
var withStyles = require('../../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Snackbar = require('../../../node_modules/@material-ui/core/esm/Snackbar/Snackbar.js');
var Slide = require('../../../node_modules/@material-ui/core/esm/Slide/Slide.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function TransitionFromTop(props) {
  return React__default["default"].createElement(Slide["default"], _objectSpread({}, props, {
    direction: "down"
  }));
}

function TransitionFromBottom(props) {
  return React__default["default"].createElement(Slide["default"], _objectSpread({}, props, {
    direction: "up"
  }));
}

var InnerAlert = withStyles({
  root: {
    width: '100%',
    borderRadius: 0
  }
})(AlertMessage);
var ToasterAlertWithRef = React.forwardRef(function ToasterAlert(_ref, ref) {
  var open = _ref.open,
      _ref$classes = _ref.classes,
      root = _ref$classes.root,
      closedRoot = _ref$classes.closedRoot,
      anchorOriginTop = _ref$classes.anchorOriginTop,
      anchorOriginBottom = _ref$classes.anchorOriginBottom,
      alertRoot = _ref$classes.alertRoot,
      alertClasses = objectWithoutProperties(_ref$classes, ["root", "closedRoot", "anchorOriginTop", "anchorOriginBottom", "alertRoot"]),
      _ref$anchorOrigin = _ref.anchorOrigin,
      anchorOrigin = _ref$anchorOrigin === void 0 ? 'top' : _ref$anchorOrigin,
      _ref$autoHideDuration = _ref.autoHideDuration,
      autoHideDuration = _ref$autoHideDuration === void 0 ? 3000 : _ref$autoHideDuration,
      _ref$onClose = _ref.onClose,
      handleClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? false : _ref$showCloseButton,
      _ref$closeOnClickAway = _ref.closeOnClickAway,
      closeOnClickAway = _ref$closeOnClickAway === void 0 ? false : _ref$closeOnClickAway,
      alertProps = objectWithoutProperties(_ref, ["open", "classes", "anchorOrigin", "autoHideDuration", "onClose", "showCloseButton", "closeOnClickAway"]);

  return React__default["default"].createElement(Snackbar["default"], {
    open: open,
    ref: ref,
    autoHideDuration: autoHideDuration,
    classes: {
      root: classNames__default["default"](root, defineProperty({}, closedRoot, open === false)),
      anchorOriginTopCenter: anchorOriginTop,
      anchorOriginBottomCenter: anchorOriginBottom
    },
    onClose: function onClose(_event, reason) {
      if (closeOnClickAway === false && reason === 'clickaway') {
        return;
      }

      handleClose(reason);
    },
    anchorOrigin: {
      vertical: anchorOrigin,
      horizontal: 'center'
    },
    TransitionComponent: anchorOrigin === 'top' ? TransitionFromTop : TransitionFromBottom
  }, React__default["default"].createElement(InnerAlert, _objectSpread({
    classes: _objectSpread({}, alertClasses, {
      root: alertRoot
    }),
    onClose: showCloseButton ? function () {
      handleClose('close-button');
    } : undefined
  }, alertProps)));
});
var ToasterAlert = withStyles(function (theme) {
  return {
    root: {
      position: 'absolute',
      transform: 'none',
      width: '100%',
      left: 0
    },
    icon: {
      marginRight: theme.spacing(0.75)
    },
    anchorOriginTop: {
      top: 0
    },
    anchorOriginBottom: {
      bottom: 0
    },
    message: {
      lineHeight: '24px'
    },
    alertRoot: {
      color: '#263238',
      paddingTop: theme.spacing(1.625),
      paddingBottom: theme.spacing(1.625),
      alignItems: 'center'
    }
  };
})(ToasterAlertWithRef);
ToasterAlert.displayName = 'ToasterAlert';

module.exports = ToasterAlert;
